import { useEffect } from 'react';
import {Outlet, Navigate, Route} from 'react-router-dom';
import {useAppStore} from '@/store/appStore.ts';
import {AppHeader} from './AppHeader';
import {Spinner} from '../common/Spinner';

const TOKEN_KEY = 'auth_token';

export default function MainLayout() {

    const init = useAppStore((s) => s.init);
    const user = useAppStore((s) => s.user);
    const loading = useAppStore((s) => s.loading);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('accesstoken');
        if (token) {
            localStorage.setItem(TOKEN_KEY, token);
            params.delete('accesstoken');
            const query = params.toString();
            const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
            window.history.replaceState(null, document.title, cleanUrl);
        }
        init();
    }, [init]);


    if (loading) {
        return (
            <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Spinner/>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login-manual" replace/>;
    }

    return (
        <div style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
            <AppHeader/>
            <div style={{flex: 1, marginTop: 60, overflow: 'hidden'}}>
                <Outlet/>
            </div>
        </div>
    );
}
